import { ENDPOINTS, getFullUrl } from "../config";

export class ReturnItemService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }
  static getRole(): string | null {
    return localStorage.getItem("auth_user");
  }

  static async getReturnItemListing(params: {
    page?: number;
    pageSize?: number;
    searchText?: string;
    clinicId?: string;
  }) {
    try {
      const url = new URL(getFullUrl(ENDPOINTS.RETURN.RETURN_ITEM_LISTING));
      url.searchParams.set("status", "returned_requested");
      url.searchParams.set("page", params.page?.toString() || "1");
      url.searchParams.set("pageSize", params.pageSize?.toString() || "10");
      url.searchParams.set("clinicId", params.clinicId?.toString() || "");

      if (params.searchText) {
        url.searchParams.set("searchText", params.searchText);
      }

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }

  static async getReturnAcceptedItemListing(params: {
    page?: number;
    pageSize?: number;
    searchText?: string;
    clinicId: string,
  }) {
    try {
      const url = new URL(getFullUrl(ENDPOINTS.RETURN.RETURN_ITEM_LISTING));
      url.searchParams.set("status", "returned_accepted");
      url.searchParams.set("page", params.page?.toString() || "1");
      url.searchParams.set("pageSize", params.pageSize?.toString() || "10");
      url.searchParams.set("clinicId", params.clinicId?.toString() || "");

      if (params.searchText) {
        url.searchParams.set("searchText", params.searchText);
      }

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }

  static async updateReturnAcceptItemStatus(orderId: number,status:string) {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.RETURN.UPDATE_RETURN_STATUS}`
      );

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({
          status: status,
          returnOrderId: orderId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }

  static async updateReturnRejectItemStatus(orderId: number) {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.RETURN.UPDATE_RETURN_STATUS}/${orderId}`
      );

      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({
          returnStatus: "RETURN_REJECTED",
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }

  static async getReturnItemDetails(orderId: number) {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.RETURN.RETURN_ITEM_DETAILS_BY_ID}/${orderId}`
      );
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }

  static async updateInventoryItem(orderId: number, clinicId: string) {
    try {
      const url = getFullUrl(`${ENDPOINTS.RETURN.UPDATE_INVENTORY}/${orderId}`);
      const response = await fetch(url, {
        method: "PUT",
        headers: {
        "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({
          clinicId: clinicId,
          returnId: orderId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }

  static async updateReturnCompletedItemStatus(orderId: number) {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.RETURN.UPDATE_INVENTORY}`
      );

      const response = await fetch(url, {
        method: "PUT",
        headers: {
        "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        body: JSON.stringify({
          returnOrderId: orderId,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }

  static async getReturnItemHistoryListing(page = 1, pageSize = 10) {
    try {
      const url = new URL(getFullUrl(ENDPOINTS.RETURN.RETURN_ITEM_LISTING));
      url.searchParams.set("status", "RETURN_COMPLETED");
      url.searchParams.append("page", page.toString());
      url.searchParams.append("pageSize", pageSize.toString());

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }
      const result = await response.json();

      return {
        data: result?.data || [],
        pagination: {
          page: result?.pagination?.page || page,
          pageSize: result?.pagination?.pageSize || pageSize,
          totalCount: result?.pagination?.totalCount || 0,
          totalPages: result?.pagination?.totalPages || 0,
        },
      };
    } catch (error) {
      console.error("Failed to return items:", error);
      throw error;
    }
  }
}
